<template>
  <div class="flex flex-col min-h-0 min-w-0 w-full h-full">
    <div
      class="border-b border-mid-neutral-50 h-14 flex items-center justify-between px-6 bg-white z-10 shrink-0"
    >
      <div class="flex items-center gap-2 text-dark-neutral-500">
        <span class="material-symbols-outlined">massage</span>
        <h2 class="font-semibold">Contact</h2>
      </div>
    </div>

    <div class="px-6 py-4 overflow-hidden flex">WIP</div>
  </div>
</template>
